import { StateCreator } from "zustand";
import { State } from "./types";
import { initialState } from "./utils";
import { TableConfig } from "../../types/types";

import { supabase } from "../../../../lib/supabase";
import { SupabaseTableEnum } from "../../../../lib/supabase/supabaseTypes";
import { Logger } from "../../../../lib/logger/Logger";

export interface ConfigSlice extends State {
	gridLoading: boolean;
	gridConfig: TableConfig | null;
	updateGridConfig: (newConfig: TableConfig) => Promise<void>;
	fetchGridConfig: () => Promise<void>;
}

export const createConfigStore: StateCreator<ConfigSlice> = (set, get) => ({
	...initialState,
	gridLoading: false,
	gridConfig: null,
	fetchGridConfig: async () => {
		set({ gridLoading: true });
		const userId = get().userId;
		if (!userId) {
			set({ gridLoading: false });
			return;
		}

		const { data, error } = await supabase
			.from(SupabaseTableEnum.PROFILES)
			.select("*")
			.eq("id", userId);

		if (!error && data?.length) {
			const rawConfig = data[0]?.grid_config_job_items;
			if (rawConfig) {
				const parsed =
					typeof rawConfig === "string"
						? JSON.parse(rawConfig)
						: rawConfig;
				set({ gridConfig: parsed as TableConfig });
			}
		}
		set({ gridLoading: false });
	},
	updateGridConfig: async (newConfig: TableConfig) => {
		const oldConfig = get().gridConfig;
		set({ gridConfig: newConfig });

		const userId = get().userId;
		if (!userId) return;

		const { error } = await supabase
			.from(SupabaseTableEnum.PROFILES)
			.update({ grid_config_job_items: JSON.stringify(newConfig) })
			.eq("id", userId);

		if (error) {
			set({ gridConfig: oldConfig });
			Logger.error(error, {}, "Error updating grid config");
			return;
		}
	},
});
